import * as React from "react";

import {compose} from "redux";
import {connect} from "react-redux";
import {translate} from "react-i18next";
import {t} from "i18next";
import {Icon} from "semantic-ui-react";

import Dialog from "../../../components/Dialogs/Dialog";
import Button from "../../../components/Button";
import {FlagDto, OptionDto, OptionFlagMultiUpdateParam, OptionFlagMultiUpdateParamActionType, RoleDto} from "../../../services/Client";

import DataAdapterOptionsView from "../DataAdapterOptionsView";
import {selectUserRoles} from "../../../redux/selectors";
import {IReduxState} from "src/redux/IReduxState";
import {EStepTab, StepHeader, stepTabList} from "../workflowStatusMultiUpdate/WSMUUtils";
import {SelectType} from "../workflowStatusMultiUpdate/WSMUSummaryUtils";

import {FlagActionSelection} from "./FlagActionSelection";
import {FMUSummary} from "./FMUSummary";
import {FMUConfirmDialog} from "./FMUConfirmDialog";

interface IMapStateToProps {
    userRoles: RoleDto[];
}

interface IOwnProps {
    // selected items
    items: DataAdapterOptionsView[];
    flagMultiUpdateErrorResult?: number;

    // actions
    onSubmit: (param: OptionFlagMultiUpdateParam) => void;
    onClose: () => void;
    onRefresh: () => void;
    flags?: FlagDto[];
}

interface IMultiFlagUpdateDialogProps extends IMapStateToProps, IOwnProps { }

interface IMultiFlagUpdateDialogState {
    activeTab: number;
    actionType?: OptionFlagMultiUpdateParamActionType;
    itemsToUpdate: DataAdapterOptionsView[];
    loaderActive: boolean;
    updatedFlag: FlagDto[];
    alreadyExistFlags: FlagDto[];
    disableNext: boolean;
}

class FlagMultiUpdateDialog extends
    React.Component<IMultiFlagUpdateDialogProps,
        IMultiFlagUpdateDialogState> {
    constructor(props: IMultiFlagUpdateDialogProps) {
        super(props);

        this.state = {
            activeTab: EStepTab.ActionTab,
            loaderActive: false,
            itemsToUpdate: [],
            updatedFlag: [],
            alreadyExistFlags: [],
            disableNext: true
        };
    }
    componentDidMount(): void {
        const alreadyExistFlags: FlagDto[] = [];
        const updatedItems = this.props.items.map(item => {
            item.dto.isChecked = true;
            if (item.flags) {
                item.flags.map(flag => {
                    const check = alreadyExistFlags.find(p => p.objectId === flag.objectId);
                    if (!check) {
                        alreadyExistFlags.push(flag);
                    }
                }
                );
            }
            return item;
        });

        this.setState({ itemsToUpdate: updatedItems, updatedFlag: alreadyExistFlags, alreadyExistFlags });
    }
    componentDidUpdate(prevProps: Readonly<IMultiFlagUpdateDialogProps>): void {
        if (this.props.flagMultiUpdateErrorResult !== undefined &&
            prevProps.flagMultiUpdateErrorResult !== this.props.flagMultiUpdateErrorResult) {
            this.setState({
                activeTab: EStepTab.ResultTab,
                loaderActive: false
            });
        }

    }
    private handleSelectChange = (selectType: SelectType, optionDto?: OptionDto, isChecked?: boolean) => {
        let { itemsToUpdate } = this.state;
        switch (selectType) {
            case SelectType.SelectAll:
                itemsToUpdate = itemsToUpdate.map(item => {
                    item.dto.isChecked = true;
                    return item;
                });
                break;
            case SelectType.SingleSelect:
                if (optionDto) {
                    itemsToUpdate = itemsToUpdate.map(item => {
                        if (item.dto.objectId === optionDto.objectId) {
                            item.dto.isChecked = isChecked;
                            return item;
                        }
                        return item;
                    });
                }

                break;
            case SelectType.DeselectAll:
                itemsToUpdate = itemsToUpdate.map(item => {
                    item.dto.isChecked = false;
                    return item;
                });
                break;
            default:

                break;
        }
        this.setState({ itemsToUpdate });
    }

    private onSubmit = () => {
        if (this.state.actionType) {
            this.setState({ loaderActive: true });
            const options = this.state.itemsToUpdate.filter(p => p.dto.isChecked).map(item => {
                return {
                    objectId: item.dto.objectId,
                    versionId: item.dto.versionId
                };
            });
            let updatedFlags: FlagDto[];
            if (this.state.actionType === OptionFlagMultiUpdateParamActionType.ADD) {
                updatedFlags = this.state.updatedFlag.map(item => {
                    delete item.links;
                    return item;
                });
            } else {
                updatedFlags = [];
                this.state.alreadyExistFlags.map(flag => {
                    const found = this.state.updatedFlag.find(p => p.objectId === flag.objectId);
                    if (!found) {
                        updatedFlags.push(flag);
                    }
                });
            }
            const param: OptionFlagMultiUpdateParam = {
                actionType: this.state.actionType,
                flags: updatedFlags,
                options,
                links: []
            };

            this.props.onSubmit(param);
        }
    }

    render() {
        const dlgButton = this.state.activeTab === EStepTab.ResultTab
            ? (
                <Button
                    key={"refreshButton"}
                    icon={"refresh"}
                    onClick={this.props.onRefresh}
                    disabled={this.state.loaderActive}
                />
            )
            : (
                <Button
                    key={"cancelButton"}
                    icon={"ban"}
                    onClick={this.props.onClose}
                    disabled={this.state.loaderActive}
                />
            );

        return (
            <Dialog
                open={true}
                title={t("PSL_FLAG_MULTI:UPDATE_FLAG_DLG_TITLE")}
                customStyleClassName={'multi-step-dialog'}
                actions={[dlgButton]}
            >
                <div style={{ marginBottom: '30px' }}>
                    <StepHeader
                        activeTab={this.state.activeTab}
                        steps={stepTabList}
                        t={t}
                    />
                </div>

                {/** First Tab Start */}
                {this.state.activeTab === EStepTab.ActionTab &&
                    <FlagActionSelection
                        value={this.state.actionType}
                        validItems={this.state.itemsToUpdate}
                        t={t}
                        flags={this.props.flags || []}
                        disableNext={this.state.disableNext}
                        onChange={(actionType) => this.setState({ actionType })}
                        nextAction={() =>
                            this.setState({
                                activeTab: this.state.activeTab + 1,
                            })
                        }
                        OnAddDeleteChange={(value: any) => {
                            const selectedValues = value.map((p: any) => p.selectedValue);
                            this.setState({ updatedFlag: selectedValues, disableNext: false });
                        }}
                        updatedFlag={this.state.updatedFlag}
                    />
                }
                {/** First Tab End */}

                {/** Second Tab Start */}
                {this.state.activeTab === EStepTab.SummaryTab && this.state.actionType &&
                    <FMUSummary
                        validItems={this.state.itemsToUpdate}
                        actionType={this.state.actionType}
                        updatedFlags={this.state.updatedFlag}
                        alreadyExistFlags={this.state.alreadyExistFlags}
                        t={t}
                        handleSelectChange={this.handleSelectChange}
                        backAction={() => this.setState({ activeTab: this.state.activeTab - 1 })}
                        nextAction={() => this.setState({ activeTab: this.state.activeTab + 1 })}
                    />

                }
                {/** Second Tab End */}

                {/** Third Tab Start */}
                {this.state.activeTab === EStepTab.ConfirmTab && this.state.actionType && this.state.itemsToUpdate.length > 0 &&
                    <FMUConfirmDialog
                        actionType={this.state.actionType}
                        itemsToUpdateCount={this.state.itemsToUpdate.filter(p => p.dto.isChecked).length}
                        t={t}
                        onSubmit={this.onSubmit}
                        loaderActive={this.state.loaderActive}
                        backAction={() => this.setState({ activeTab: this.state.activeTab - 1 })}
                    />

                }
                {/** Third Tab End */}

                {/** Fourth Tab Start */}
                <>
                    {this.state.activeTab === EStepTab.ResultTab && this.props.flagMultiUpdateErrorResult !== undefined &&
                        <>
                            <p>
                                <b>{this.state.itemsToUpdate.length - this.props.flagMultiUpdateErrorResult}</b>
                                {' ' + t("PSL_WF_S_MULTI:RESULT_SUCCESS")}
                            </p>
                            {this.props.flagMultiUpdateErrorResult > 0 &&
                                <div className={"display--flex"}>
                                    <Icon name="exclamation triangle" color="red" />
                                    <p>
                                        <b style={{ color: 'red' }}>{this.props.flagMultiUpdateErrorResult}</b>
                                        {' ' + t("PSL_WF_S_MULTI:RESULT_ERROR")}

                                    </p>
                                </div>
                            }
                        </>
                    }
                </>
                {/** Fourth Tab End */}
            </Dialog>
        );
    }
}

const mapStateToProps = (state: IReduxState): IMapStateToProps => ({
    userRoles: selectUserRoles(state) || [],
});

export default compose<React.ComponentType<IOwnProps>>(
    translate(["PSL_FLAG_MULTI", "PSL_WF_S_MULTI"]),
    connect<IMapStateToProps>(mapStateToProps))
    (FlagMultiUpdateDialog);



// WEBPACK FOOTER //
// ./src/views/OptionsView/MultipleFlagUpdate/FlagMultiUpdateDialog.tsx